const branding = {
  id: "branding",
  title: "Branding, Theming & Experience Design",
  questions: [
    {
      question: "How do you align the event theme with our brand identity?",
      answer: "We study your brand guidelines, objectives, and audience profile before designing a concept that reflects your brand personality."
    },
    {
      question: "Can you customize themes as per our campaign or annual goal?",
      answer: "Yes. Every concept is tailor-made to align with your product launch, sales target theme, or corporate message."
    },
    {
      question: "Do you manage complete branding production on-site?",
      answer: "Yes. We handle stage design, LED visuals, backdrops, standees, and branded collaterals end-to-end."
    },
    {
      question: "Can you create immersive experience setups instead of standard events?",
      answer: "Absolutely. We design experiential zones, interactive elements, and thematic storytelling setups."
    },
    {
      question: "How early do you present theme concepts?",
      answer: "Initial creative directions are shared during the proposal stage, followed by detailed mockups after confirmation."
    },
    {
      question: "Do you provide 3D stage or venue layout previews?",
      answer: "Yes. We share visual layouts and concept references to give clarity before execution."
    },
    {
      question: "Can you manage gala nights or award ceremonies with custom themes?",
      answer: "Yes. From entry experiences to stage scripting, lighting, and entertainment flow — everything is theme-integrated."
    },
    {
      question: "How do you ensure brand visibility throughout the event?",
      answer: "Through strategic placement of logos, digital screens, printed elements, and branded engagement activities."
    },
    {
      question: "Can you handle celebrity artists or entertainment bookings?",
      answer: "Yes. We coordinate artist sourcing, contracts, technical riders, and performance logistics."
    },
    {
      question: "What makes your experience design different from local planners?",
      answer: "We combine strategic brand alignment, structured production planning, and execution control — not just decoration or basic setup."
    }
  ]
};

export default branding;
